import { useEffect, useRef, useState } from "react"
import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import { Button } from "components/Feature/Custom/Button";


export const HeroPlayer = ({src, poster, isPaused,title, description, buttonText,
     buttonLink,buttonLinkType, buttonLinkTarget, isMobile, locale, lang, index})=>{
    const videoRef = useRef([])
    const playRef = useRef()
    const pauseRef = useRef()
    const [mounted, setMounted] = useState();
    useEffect(()=>{
        setMounted(true)
    })
    // mounted && document.querySelectorAll('.hero-vid').forEach(vid => vid.volume = 0.2)
    mounted && document.querySelectorAll('.hero-vid').forEach(vid => {vid.removeAttribute('controls'); vid.setAttribute("muted","true")})
    return <>
    <div className="w-full h-full absolute top-0 z-10 left-0 bg-black opacity-10" />
    <video
        className="hero-vid w-full h-full object-cover absolute -z-20"
        ref={videoRef}
        src={src}
        poster={poster}
        preload={index === 0 ? "auto" : "metadata"}
        loop
        muted
        autoPlay
        controls={false}
        webkit-playsinline
        playsInline
        data-swiper-parallax={isMobile ? index==0?"":"300" : "0"}
        aria-label={title || "Hero video"}
      >
        <track kind="captions" />
      </video>
    <div className={`responsive m-auto text-start relative md-hero-height-mt
        flex flex-col justify-end min-h-[70vh] md:min-h-screen w-full z-[50] bottom-[10%] transition-opacity md:justify-center md:bottom-0
         ${locale == lang? "rtl": ""}`}>
        {title && <div>
        <h1 className="text-[32px] md:pb-4 md:text-3brand h-md:lg:text-2brand md:max-w-[60%] lg:max-w-[50%] 2xl:max-w-[35%]"
            data-swiper-parallax={"-600"}>{title}</h1>
        </div>}
        {description?.value && <div className="text-[18px] md:text-5brand max-w-[90%] my-2 md:my-0 md:max-w-[60%] lg:max-w-[50%] 2xl:max-w-[35%] xl:text-2xl text-justify" data-swiper-parallax={"-1500"}>
            <RichText field={description} />
        </div>}
        <div class='flex align-center gap-4 md:gap-8 md:mt-8' data-swiper-parallax={"-2000"}>
            {false && <div className={`border-solid border-[1px] border-white flex justify-center items-center scale-[0.8] md:scale-100
             hover:bg-brand-1000 hover:border-brand-1000 group ease-in-out duration-300 transition-colors
              min-h-[57px] w-[60px] md:min-h-[48px] md:w-[60px] h-md:md:min-h-[58px] h-md:md:w-[58px]
             `}>
               <svg id="playButton" ref={playRef} className={`hero-vid-play-icon fill-white z-[50] cursor-pointer
                f ease-in-out duration-400 w-[40px] h-[40px]
                transition-colors`} xmlns="http://www.w3.org/2000/svg" height="48" width="48"
                aria-label="Play video"
                onClick={()=>{
                    document.querySelectorAll('.hero-vid').forEach(vid => vid.pause());
                    playRef.current.classList.add('hidden')
                    pauseRef.current.classList.remove('hidden')
                    videoRef.current.play()
                }}>
                    <path d="M18 34.3V13.55l16.3 10.4Zm1.55-10.35Zm0 7.55 11.95-7.55-11.95-7.55Z"/>
                </svg>
                <svg id="playButton" ref={playRef} xmlns="http://www.w3.org/2000/svg" width="19" height="22" viewBox="0 0 19 22"
                className={`hero-vid-play-icon hidden cursor-pointer ${locale == lang ? "translate-x-[2px]":"translate-x-[2px]"}`}
                aria-label="Play video"
                onClick={()=>{
                    document.querySelectorAll('.hero-vid').forEach(vid => vid.pause());
                    playRef.current.classList.add('hidden')
                    pauseRef.current.classList.remove('hidden')
                    videoRef.current.play()
                }}
                >
                    <g id="Polygon_1" data-name="Polygon 1" transform="translate(19) rotate(90)" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9.269,2.99a2,2,0,0,1,3.462,0L20.262,16a2,2,0,0,1-1.731,3H3.469a2,2,0,0,1-1.731-3Z" stroke="none"/>
                        <path d="M 10.99999904632568 3.491722106933594 C 10.89233875274658 3.491722106933594 10.69295883178711 3.524131774902344 10.56728935241699 3.741201400756836 L 3.036178588867188 16.74949264526367 C 2.910249710083008 16.96700286865234 2.981838226318359 17.15627288818359 3.035728454589844 17.24974250793457 C 3.089618682861328 17.34320259094238 3.217548370361328 17.50000190734863 3.468898773193359 17.50000190734863 L 18.53110885620117 17.50000190734863 C 18.78244972229004 17.50000190734863 18.91037940979004 17.34320259094238 18.96426963806152 17.24974250793457 C 19.01815986633301 17.15628242492676 19.08974838256836 16.96700286865234 18.96381950378418 16.74948120117188 L 11.43270874023438 3.741212844848633 C 11.30703926086426 3.524131774902344 11.10765933990479 3.491722106933594 10.99999904632568 3.491722106933594 M 10.99999904632568 1.991724014282227 C 11.67284107208252 1.991724014282227 12.34568405151367 2.324367523193359 12.73084926605225 2.989652633666992 L 20.26195907592773 15.99793243408203 C 21.03388977050781 17.33126258850098 20.07176971435547 19.00000190734863 18.53110885620117 19.00000190734863 L 3.468898773193359 19.00000190734863 C 1.928228378295898 19.00000190734863 0.9661083221435547 17.33126258850098 1.738039016723633 15.99793243408203 L 9.269148826599121 2.989652633666992 C 9.654314041137695 2.324367523193359 10.32715702056885 1.991724014282227 10.99999904632568 1.991724014282227 Z" stroke="none" fill="#fff"/>
                    </g>
                </svg>

                <svg id="pauseButton" ref={pauseRef} className="hero-vid-pause-icon fill-white cursor-pointer ease-in-out duration-400 transition-colors" xmlns="http://www.w3.org/2000/svg" height="48" width="48"
                    aria-label="Pause video"
                    onClick={()=>{
                    document.querySelectorAll('.hero-vid').forEach(vid => vid.pause());
                    pauseRef.current.classList.add('hidden')
                    playRef.current.classList.remove('hidden')
                    videoRef.current.pause()
                    videoRef.current.poster = poster
                }}>
                    <path d="M29.15 36V12h6v24Zm-16.3 0V12h6.05v24Z" className="fill-none stroke-white"/>
                </svg>
            </div>}
            {buttonText && <div className="flex items-center mt-1 md:mt-0">
                <Button
                    classNames={`self-start hover:bg-brand-1000 hover:border-brand-1000 !text-[16px] !border-[1px] !px-4 !py-[0.7rem] h-md:md:!px-8 h-md:md:!py-4`}
                    redirect={buttonLink}
                    text={buttonText}
                    target={buttonLinkTarget}
                    linktype={buttonLinkType}
                />
            </div>}
        </div>
    </div>
    </>
}